/** Parse a free-text or numeric amount into a clamped, rounded integer.
 *  Empty/invalid input falls back to `min` so a weight field never goes NaN. */
export function clampAmount(raw: string | number, min: number, max: number): number {
  const n = typeof raw === "number" ? raw : parseFloat(String(raw).replace(",", "."));
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, Math.round(n)));
}
